/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Linguistics18Inputs */

const en__field__enum_primarystudyinterest_study_linguistics18 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Linguistics18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linguistics`)
};

const de__field__enum_primarystudyinterest_study_linguistics18 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Linguistics18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linguistik`)
};

/**
* | output |
* | --- |
* | "Linguistics" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Linguistics18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_linguistics18 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Linguistics18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Linguistics18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_linguistics18(inputs)
	return de__field__enum_primarystudyinterest_study_linguistics18(inputs)
});
export { _field__enum_primarystudyinterest_study_linguistics18 as "_field__enum_primaryStudyInterest_STUDY_LINGUISTICS" }